import React from 'react';
import { User } from 'lucide-react';
import MarkdownRenderer from './MarkdownRenderer';
import peppaLogo from "../../assets/icons/peppa_logo_white_sq.svg";

const MessageBubble = ({ message, isLast }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString('fr-FR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const isUser = message.sender === 'user';

  return (
    <div
      className={`flex gap-4 ${
        isUser ? "justify-end" : "justify-start"
      } animate-in slide-in-from-bottom-2 duration-300`}
    >
      {!isUser && (
        <div className="w-8 h-8 bg-gradient-to-br from-primary to-cyan-500 dark:from-primary dark:to-sky-500 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
          {/* <Bot className="w-4 h-4 text-white" /> */}
          <img src={peppaLogo} alt="Peppa Logo" className="w-4 text-white" />
        </div>

      )}
      
      <div className={`max-w-3xl relative ${
        isUser ? "order-2" : "order-1"
      }`}>
        <div className={`rounded-2xl px-4 py-3 shadow-sm ${
          isUser
            ? "bg-gradient-to-br from-primary to-sky-500 text-primary-foreground"
            : "bg-card/80 dark:bg-card/70 border border-border/30 text-foreground"
        }`}>
          <div className="leading-relaxed">
            {!isUser ? (
              <MarkdownRenderer content={message.text} />
            ) : (
              <div className="whitespace-pre-wrap">{message.text}</div>
            )}
          </div>
          
          {/* Copy button removed as requested */}
        </div>
        
        <div className={`text-xs text-muted-foreground mt-2 flex items-center gap-2 ${
          isUser ? "justify-end" : "justify-start"
        }`}>
          <span>{formatTime(message.timestamp)}</span>
          {!isUser && (
            <span className="text-primary">
              Peppa AI
            </span>
          )}
        </div>
      </div>
      
      {isUser && (
        <div className="w-8 h-8 bg-gradient-to-r from-gray-500 to-gray-600 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
          <User className="w-4 h-4 text-white" />
        </div>
      )}
    </div>
  );
};

export default MessageBubble; 